/**
 * @module qbLinkage/detectChanges/detectCompareTimeChanges
 * @description 仅 compareTime 类别
 */

import type { IQBSnapshot, TQBEvent } from '../types';
import { detectCompareTime } from './detectCompareTime';
import type { IPartialQBChangeSet } from './partialChangeSet';

export function detectCompareTimeChanges(
  _prev: IQBSnapshot,
  next: IQBSnapshot,
): IPartialQBChangeSet {
  const events: TQBEvent[] = ['compareTimeChanged'];
  const nextCompare = detectCompareTime(next.columnFilters);

  return {
    events,
    compareTime: nextCompare,
  };
}
